import { useLocation } from 'react-router-dom-v5-compat';

import { ROUTE_PARAMS } from 'src/routes';

export const useQueryParamProjectFolderId = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get(ROUTE_PARAMS.folder);
};
